// Sudoku Solver — i18n index
// Tek kaynak: shared/src/i18n/*.json dosyaları.
// Yeni çeviri eklemek için shared/src/i18n/*.json dosyalarını güncelle.

import {
  trLocale as tr, enLocale as en, nlLocale as nl, frLocale as fr,
  deLocale as de, itLocale as it, plLocale as pl, ruLocale as ru, esLocale as es,
} from '@sudoku/shared';

export type Locale = 'tr' | 'en' | 'nl' | 'fr' | 'de' | 'it' | 'pl' | 'ru' | 'es';

/** Kodun bildiği tüm diller (mimari destekliyor, içerik İngilizce placeholder olabilir). */
export const ALL_LOCALES: Locale[] = ['tr', 'en', 'nl', 'fr', 'de', 'it', 'pl', 'ru', 'es'];

/**
 * Gerçek çevirisi tamamlanmış ve canlıya çıkmış diller.
 * Yeni bir dilin (örn. nl) çevirisi tamamlanınca SADECE bu listeye eklenmesi
 * yeterli — LangToggle, sitemap ve hreflang otomatik devreye girer.
 * (generate-sitemap.mjs ve prerender.mjs'te de aynı listenin elle senkron
 * tutulması gerekiyor — bkz. oradaki yorumlar.)
 */
export const LIVE_LOCALES: Locale[] = ['tr', 'en', 'nl', 'fr', 'de', 'it', 'pl', 'ru', 'es'];

/** LangToggle dropdown'ında gösterilecek doğal dil adları. */
export const LOCALE_NATIVE_NAMES: Record<Locale, string> = {
  tr: 'Türkçe', en: 'English', nl: 'Nederlands', fr: 'Français',
  de: 'Deutsch', it: 'Italiano', pl: 'Polski', ru: 'Русский', es: 'Español',
};

// difficulties JSON'da string key ("1","2",...) ama kod number ile erişiyor.
// Bu tip override ikisini uzlaştırır; component'lerde değişiklik gerekmez.
type RawTranslations = typeof tr;
export type Translations = Omit<RawTranslations, 'difficulties'> & {
  difficulties: Record<number, string>;
};

const LOCALES: Record<Locale, Translations> = {
  tr: tr as Translations,
  en: en as Translations,
  nl: nl as Translations,
  fr: fr as Translations,
  de: de as Translations,
  it: it as Translations,
  pl: pl as Translations,
  ru: ru as Translations,
  es: es as Translations,
};

export const TR: Translations = LOCALES.tr;
export const EN: Translations = LOCALES.en;

export function getTranslations(locale: Locale): Translations {
  return LOCALES[locale] ?? LOCALES.tr;
}

export function isLocale(value: string): value is Locale {
  return (ALL_LOCALES as string[]).includes(value);
}

export function isLiveLocale(value: string): value is Locale {
  return (LIVE_LOCALES as string[]).includes(value);
}
